export const AUTH_TOKENS = 'authTokens'
export const CLIENT_ID = 'clientId'
